import { FolderBreadcrumb } from '../store/schema/FolderBreadcrumb';
import { getOwaCommonStrings } from 'owa-strings/owa-common-strings';
import { getSelectedProvider } from './selectedProviderSelectors';
import { getStore } from '../store/store';
import { PROVIDER_ROOT_FOLDER_BREADCRUMB_ID } from '../constants';

export function getAllBreadcrumbs(): FolderBreadcrumb[] {
    const breadcrumbs = getStore().breadcrumbs;

    return [...getDefaultBreadcrumbs(), ...breadcrumbs];
}

export function getBreadcrumbForFolderId(folderId: string): FolderBreadcrumb | null {
    const [breadcrumb] = getAllBreadcrumbs().filter(breadcrumb => breadcrumb.id === folderId);

    return breadcrumb || null;
}

export function getFolderIdForTopBreadcrumb(): string | null {
    const breadcrumb = getTopBreadcrumb();

    return breadcrumb ? breadcrumb.id : null;
}

export function getTopBreadcrumbName(): string | null {
    const breadcrumb = getTopBreadcrumb();

    return breadcrumb ? breadcrumb.name : null;
}

export function isTopBreadcrumbRoot(): boolean {
    const breadcrumb = getTopBreadcrumb();

    return breadcrumb && breadcrumb.id === PROVIDER_ROOT_FOLDER_BREADCRUMB_ID;
}

function getTopBreadcrumb(): FolderBreadcrumb | null {
    const breadcrumbs = getAllBreadcrumbs();

    if (breadcrumbs.length > 0) {
        return breadcrumbs[breadcrumbs.length - 1];
    }

    return null;
}

function getDefaultBreadcrumbs(): FolderBreadcrumb[] {
    const selectedProvider = getSelectedProvider();

    if (selectedProvider) {
        return [
            {
                key: 'root',
                id: PROVIDER_ROOT_FOLDER_BREADCRUMB_ID,
                name: selectedProvider.name,
            },
            {
                key: 'files',
                id: PROVIDER_ROOT_FOLDER_BREADCRUMB_ID,
                name: getOwaCommonStrings().filesBreadcrumb,
            },
        ];
    }

    return [];
}
